export { defaultMatDialogProvider } from './lib/ui/default-mat-dialog.provider';
export { MessageDialogComponent } from './lib/ui/message-dialog.component';

export { isDialogMessageOptions } from './lib/type/is-dialog-message-options';
export { isToastMessageOptions } from './lib/type/is-toast-message-options';
export {
  type ButtonHide,
  type ButtonShow,
  type Button,
  type MessageOptions,
  type DialogMessageOptions,
  type ToastMessageOptions,
  type MessageType,
} from './lib/type/message-options';
export { type MessageResult } from './lib/type/message-result';

export { MessageService } from './lib/service/message.service';
export {
  type OpenDialogOptionsParameter,
  type OpenConfirmDialogOptionsParameter,
  type OpenOKDialogOptionsParameter,
  openDialog,
  openConfirmDialog,
  openOKDialog,
} from './lib/service/open-dialog';
export {
  type OpenToastOptionsParameter,
  type OpenSuccessToastOptionsParameter,
  type OpenInfoToastOptionsParameter,
  type OpenWarningToastOptionsParameter,
  type OpenErrorToastOptionsParameter,
  openSuccessToast,
  openErrorToast,
  openInfoToast,
  openToast,
  openWarningToast,
} from './lib/service/open-toast';

export { I18nProviderInjectionToken } from './lib/i18n/i18n.scope';
